import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'

import { contributionBinPluralSlug } from 'features/ContributionLang'

import styles from 'components/Admin/Menu.module.scss'
import { Group, Context, Item } from '@piconetworks/pkg-nav-link'
import { NavBar } from '@piconetworks/ui'

const ProductsMenu = ({ router, showPasses, productsLoading }) => {
    if (productsLoading) {
        return (
            <NavBar horizontal className={styles.menu}>
            </NavBar>
        )
    }
    return (
        <section className="w-100">
            <Group
                active={router.asPath}
                onChange={(e) => {
                    router.push('/products/[section]', e, { shallow: true })
                }}
            >
                <Context.Consumer>
                    {({ isActive, setActive }) => (
                        <NavBar horizontal className={styles.menu}>
                            <Item
                                active={isActive('/products/subscriptions')}
                                onClick={() => setActive('/products/subscriptions')}
                                className={styles.submenuItem}
                            >
                                    Subscriptions
                            </Item>
                            {showPasses && (
                                <Item
                                    active={isActive('/products/passes')}
                                    onClick={() => setActive('/products/passes')}
                                    className={styles.submenuItem}
                                >
                                        Passes
                                </Item>
                            )}
                            <Item
                                active={isActive(`/products/${contributionBinPluralSlug()}`)}
                                onClick={() => setActive(`/products/${contributionBinPluralSlug()}`)}
                                className={styles.submenuItem}
                            >
                                    Tip Jars
                            </Item>
                        </NavBar>
                    )}
                </Context.Consumer>
            </Group>
        </section>
    )
}

ProductsMenu.propTypes = {
    productsLoading: PropTypes.bool,
    router: PropTypes.object,
    showPasses: PropTypes.bool,
}

export default withRouter(ProductsMenu)
